module.exports = __webpack_public_path__ + "static/media/close.aeb837dc.svg";